import React, { useEffect, useState } from "react";
import back from "../../assets/back.svg";
import { TokenModal } from "../../Modals";
import avax from "../../assets/avalanche.svg";
import useGetAmountOut from "../../hooks/useGetAmountOut";
import {
  FACTORY_Contract_Abi,
  FACTORY_Contract_Address,
  HopePepe_Contract_ABI,
  HopePepe_Contract_Address,
  HopePepePairABI,
  ROUTER_Contract_Abi,
  ROUTER_Contract_Address,
  USDC_Contract_Abi,
  USDC_Contract_Address,
  USDT_Contract_Abi,
  USDT_Contract_Address,
  WBTC_Contract_Abi,
  WBTC_Contract_Address,
} from "../../utilies/constant";
import { ethers } from "ethers";
import { useAccount, useBalance, useNetwork, useSwitchNetwork } from "wagmi";
import { useWeb3Modal } from "@web3modal/wagmi/react";
import toast from "react-hot-toast";
import {
  prepareWriteContract,
  waitForTransaction,
  writeContract,
} from "@wagmi/core";
import useTokenBalances from "../../hooks/useTokenBalances";
import axios from "axios";
import { API } from "../../API/API";
import { tokensImages } from "../../Constant";
import useTokenAllowance from "../../hooks/useTokenAllowance";

const AddLiquidity = ({ setIsAddLiquidity, addLiquidityValue }) => {
  let refreshState = null;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fromValue, setFromValue] = useState("");
  const [toValue, setToValue] = useState("");
  const [activeButton, setActiveButton] = useState(null);
  const { chain } = useNetwork();
  const { chains, switchNetwork } = useSwitchNetwork();
  const { address } = useAccount();
  const { open } = useWeb3Modal();
  const [selectedFromToken, setSelectedFromToken] = useState({
    name: "Select a currency",
    img: null,
  });
  const [selectedToToken, setSelectedToToken] = useState({
    name: "Select a currency",
    img: null,
  });
  const [contractAddresses, setContractAddresses] = useState([]);
  const [tokenAllowance, setTokenAllowance] = useState({
    USDT: 0,
    USDC: 0,
    HOPEPEPE: 0,
    WBTC: 0,
  });
  const [TokenBalance, setTokenBalance] = useState({
    USDT: 0,
    USDC: 0,
    HOPEPEPE: 0,
    WBTC: 0,
  });
  const weiValue = ethers.utils.parseEther(fromValue.toString() || "0");
  const [errorMsg, setErrorMsg] = useState("Add Liquidity");
  const [Loading, setLoading] = useState(false);

  useEffect(() => {
    if (addLiquidityValue && Object.keys(addLiquidityValue).length > 0) {
      setSelectedToToken({
        name: addLiquidityValue?.TokenBName,
        img: tokensImages[addLiquidityValue?.TokenBName],
      });
      setSelectedFromToken({
        name: addLiquidityValue?.TokenAName,
        img: tokensImages[addLiquidityValue?.TokenAName],
      });
      setContractAddresses([
        addLiquidityValue?.TokenAAddress,
        addLiquidityValue?.TokenBAddress,
      ]);
    }
  }, [JSON.stringify(addLiquidityValue)]);

  const { data, isError, isLoading } = useBalance({
    address,
  });

  const { tokenBlnc: pairValue, refetch } = useGetAmountOut(
    FACTORY_Contract_Address,
    FACTORY_Contract_Abi,
    fromValue,
    "getPair",
    [contractAddresses[0], contractAddresses[1]]
  );

  const { USDTBalance, USDCBalance, HOPEBalance, WBTCBalance } =
    useTokenBalances(fromValue, toValue, address);
  // console.log("HOPEBalance",USDCBalance)

  const { tokenBlnc: getReserves, refetch: refetchRes } = useGetAmountOut(
    pairValue,
    HopePepePairABI,
    fromValue,
    "getReserves",
    []
  );

  const { tokenBlnc: quote } = useGetAmountOut(
    ROUTER_Contract_Address,
    ROUTER_Contract_Abi,
    fromValue,
    "quote",
    [
      Number(weiValue),
      getReserves && Number(getReserves[1]),
      getReserves && Number(getReserves[0]),
    ]
  );
  const {
    USDTAllowance,
    USDCAllowance,
    HOPEAllowance,
    WBTCAllowance,
    refetch: refetchAllowance,
  } = useTokenAllowance(fromValue, toValue, address);

  useEffect(() => {
    refetchRes();
    if (
      address &&
      (selectedToToken?.name === "Select a currency" ||
        selectedFromToken?.name === "Select a currency")
    ) {
      setErrorMsg("Select a currency");
      return;
    }

    if (address && (!fromValue || !toValue)) {
      setErrorMsg("Enter Amount");
      return;
    }

    const checkBalanceAndAllowance = (tokenName, balance, allowance, value) => {
      const formattedBalance = parseFloat(balance) || 0;
      const formattedAllowance = parseFloat(
        ethers.utils.formatUnits(allowance?.toString() || "0")
      );

      // Check balance
      if (value > formattedBalance) {
        setErrorMsg("Insufficient Balance");
        return true;
      }
      if (pairValue == "0x0000000000000000000000000000000000000000") {
        setErrorMsg(`Create Pair`);
        return true;
      }

      // Check allowance (non-AVAX tokens)
      if (tokenName !== "AVAX" && value > formattedAllowance) {
        setErrorMsg(`Approve Token`);
        return true;
      }

      return false;
    };

    const tokenBalances = {
      AVAX: parseFloat(data?.formatted || "0"),
      USDT: ethers.utils.formatUnits(USDTBalance?.toString() || "0"),
      USDC: ethers.utils.formatUnits(USDCBalance?.toString() || "0"),
      HOPEPEPE: ethers.utils.formatUnits(HOPEBalance?.toString() || "0"),
      WBTC: ethers.utils.formatUnits(WBTCBalance?.toString() || "0"),
    };

    const allowances = {
      USDT: USDTAllowance,
      USDC: USDCAllowance,
      HOPEPEPE: HOPEAllowance,
      WBTC: WBTCAllowance,
    };

    const fromTokenError = checkBalanceAndAllowance(
      selectedFromToken?.name,
      tokenBalances[selectedFromToken?.name],
      allowances[selectedFromToken?.name],
      fromValue
    );

    const toTokenError = checkBalanceAndAllowance(
      selectedToToken?.name,
      tokenBalances[selectedToToken?.name],
      allowances[selectedToToken?.name],
      toValue
    );

    if (!fromTokenError && !toTokenError) {
      setErrorMsg("Add Liquidity");
    }

    setTokenBalance({
      ...TokenBalance,
      ...tokenBalances,
    });
  }, [toValue, fromValue, selectedFromToken, selectedToToken, pairValue]);

  useEffect(() => {
    if (quote && quote !== undefined) {
      setToValue(Number(quote) / 1000000000000000000 || "");
    }
  }, [quote, fromValue]);

  useEffect(() => {
    refetch();
    const AllowanceUSDT = ethers.utils.formatUnits(
      USDTAllowance?.toString() || "0"
    );

    const AllowanceUSDC = ethers.utils.formatUnits(
      USDCAllowance?.toString() || "0"
    );

    const AllowanceHope = ethers.utils.formatUnits(
      HOPEAllowance?.toString() || "0"
    );
    const AllowanceWbtc = ethers.utils.formatUnits(
      WBTCAllowance?.toString() || "0"
    );
    setTokenAllowance({
      ...tokenAllowance,
      USDT: AllowanceUSDT,
      USDC: AllowanceUSDC,
      HOPEPEPE: AllowanceHope,
      WBTC: AllowanceWbtc,
    });
  }, [fromValue, selectedFromToken, USDTAllowance, selectedToToken]);

  const handleTokenSelect = (token) => {
    if (activeButton === "from") {
      setSelectedFromToken(token);
      handleAddContractAdress("from", token);
    } else if (activeButton === "to") {
      setSelectedToToken(token);
      handleAddContractAdress("to", token);
    }
    setIsModalOpen(false);
  };

  const handleAddContractAdress = (type, token) => {
    if (type === "from") {
      setContractAddresses((prevAddresses) => {
        const updatedAddresses = [token?.ContractAddress];
        // Add the "to" address if it's already selected and isn't the same as "from"
        if (
          selectedToToken.ContractAddress &&
          selectedToToken.ContractAddress !== token?.ContractAddress
        ) {
          updatedAddresses.push(selectedToToken.ContractAddress);
        }
        return updatedAddresses;
      });
    } else {
      setContractAddresses((prevAddresses) => {
        const updatedAddresses = prevAddresses.slice(); // Create a shallow copy
        // Ensure "from" address is first and "to" address is second
        updatedAddresses[1] = token?.ContractAddress;
        // if (updatedAddresses[0] === selectedFromToken?.ContractAddress) {
        // } else {
        //   updatedAddresses.push(token?.ContractAddress);
        // }
        return updatedAddresses;
      });
    }
  };

  const [contractAddress, contractAbi] =
    selectedFromToken?.name === "USDT"
      ? [USDT_Contract_Address, USDT_Contract_Abi]
      : selectedFromToken?.name === "USDC"
      ? [USDC_Contract_Address, USDC_Contract_Abi]
      : selectedFromToken?.name === "HOPEPEPE"
      ? [HopePepe_Contract_Address, HopePepe_Contract_ABI]
      : selectedFromToken?.name === "WBTC"
      ? [WBTC_Contract_Address, WBTC_Contract_Abi]
      : [USDT_Contract_Address, USDT_Contract_Abi];

  const [toContractAddress, toContractAbi] =
    selectedToToken?.name === "USDT"
      ? [USDT_Contract_Address, USDT_Contract_Abi]
      : selectedToToken?.name === "USDC"
      ? [USDC_Contract_Address, USDC_Contract_Abi]
      : selectedToToken?.name === "HOPEPEPE"
      ? [HopePepe_Contract_Address, HopePepe_Contract_ABI]
      : selectedToToken?.name === "WBTC"
      ? [WBTC_Contract_Address, WBTC_Contract_Abi]
      : [USDT_Contract_Address, USDT_Contract_Abi];

  const handleSubmit = async () => {
    try {
      let amountIn = ethers.utils.parseEther(`${fromValue}`, "ethers");
      let amountOut = ethers.utils.parseEther(`${toValue}`, "ethers");
      const unixTime = Math.floor(Date.now() / 1000);
      const unixTimePlus300 = unixTime + 300;
      setLoading(true);
      if (pairValue == "0x0000000000000000000000000000000000000000") {
        setLoading(true);
        const { request } = await prepareWriteContract({
          address: FACTORY_Contract_Address,
          abi: FACTORY_Contract_Abi,
          functionName: "createPair",
          args: [contractAddresses[0], contractAddresses[1]],
          account: address,
        });
        const { hash } = await writeContract(request);
        const data = await waitForTransaction({
          hash,
        });

        refetch();
        refreshState = hash;
        setTimeout(() => {
          addPair();
        }, 3000);
      }

      if (
        selectedFromToken?.name !== "AVAX" &&
        Number(fromValue) > Number(tokenAllowance[selectedFromToken.name])
      ) {
        let approveValue = ethers.utils.parseEther(
          `${Number(TokenBalance[selectedFromToken?.name] - Number(0.001))}`,
          "ethers"
        );
        setLoading(true);
        const { request } = await prepareWriteContract({
          address: contractAddress,
          abi: contractAbi,
          functionName: "approve",
          args: [ROUTER_Contract_Address, Number(approveValue)],
          account: address,
        });
        const { hash } = await writeContract(request);
        const data = await waitForTransaction({
          hash,
        });
        toast.success(
          `Approve ${selectedFromToken?.name} Tokens Successfully`,
          {
            duration: 5000,
          }
        );
        refetchAllowance();
      }

      if (
        selectedToToken?.name !== "AVAX" &&
        Number(toValue) > Number(tokenAllowance[selectedToToken.name])
      ) {
        setLoading(true);
        let approveValue = ethers.utils.parseEther(
          `${Number(TokenBalance[selectedToToken?.name] - Number(0.001))}`,
          "ethers"
        );
        const { request } = await prepareWriteContract({
          address: toContractAddress,
          abi: toContractAbi,
          functionName: "approve",
          args: [ROUTER_Contract_Address, Number(approveValue)],
          account: address,
        });
        const { hash } = await writeContract(request);
        const data = await waitForTransaction({
          hash,
        });
        toast.success(`Approve ${selectedToToken?.name} Tokens Successfully`, {
          duration: 5000,
        });
        refetchAllowance();
      }

      if (
        selectedToToken?.name !== "AVAX" &&
        selectedFromToken?.name !== "AVAX"
      ) {

        setTimeout(async () => {
          setLoading(true);
          const { request } = await prepareWriteContract({
            address: ROUTER_Contract_Address,
            abi: ROUTER_Contract_Abi,
            functionName: "addLiquidity",
            args: [
              contractAddresses[0],
              contractAddresses[1],
              Number(amountIn),
              Number(amountOut),
              0,
              0,
              address,
              unixTimePlus300,
            ],
            account: address,
          });
          const { hash } = await writeContract(request);
          const data = await waitForTransaction({
            hash,
          });
          toast.success(`Liquidity add Successfully`, {
            duration: 5000,
          });
          setLoading(false);
          setFromValue("");
          setToValue("");
        }, 3000);
      } else {
        setTimeout(async () => {
          setLoading(true);
          const { request } = await prepareWriteContract({
            address: ROUTER_Contract_Address,
            abi: ROUTER_Contract_Abi,
            functionName: "addLiquidityETH",
            args: [
              selectedFromToken?.type == "Token"
                ? contractAddresses[0]
                : contractAddresses[1],
              selectedFromToken?.type == "Token"
                ? Number(amountIn)
                : Number(amountOut),
              0,
              0,
              address,
              unixTimePlus300,
            ],
            value: selectedFromToken?.type !== "Token" ? amountIn : amountOut,
            account: address,
          });
          const { hash } = await writeContract(request);
          const data = await waitForTransaction({
            hash,
          });
          toast.success(`Liquidity add Successful`, {
            duration: 5000,
          });
          setLoading(false);
          setFromValue("");
          setToValue("");
        }, 3000);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const addPair = async () => {
    try {
      let res = await API.post(`add_liquidity`, {
        UserAddress: address,
        TokenAName: selectedFromToken?.name,
        TokenBName: selectedToToken?.name,
        TokenAAddress: contractAddresses[0],
        TokenBAddress: contractAddresses[1],
        PairAddress: pairValue,
      });
      toast.success(`Pair Create Successfully`, {
        duration: 5000,
      });

      // console.log("Add Pair", res);
    } catch (error) {
      console.log("Add pair API", error);
    }
  };
  const isDisabled =
    errorMsg !== "Add Liquidity" &&
    errorMsg !== "Approve Token" &&
    errorMsg !== "Create Pair"
      ? true
      : false;

  return (
    <>
      <div className="flex items-center justify-between mb-5 px-[20px]">
        <a href="javascript:void(0)" onClick={() => setIsAddLiquidity(false)}>
          <img src={back} alt="" />
        </a>
        <div className="text-[#8c8cb1] text-[16px] font-[500]">
          Add Liquidty
        </div>
        <div />
      </div>
      <div className="px-[10px] lg:px-[20px]">
        <div className="min-h-[100px] bg-gray-100 rounded-[6px] p-[16px]">
          <div className="text-[#8c8cb1] text-[14px] font-[400]">Input</div>
          <div className="flex items-center justify-between">
            <input
              type="text"
              className="border-none w-[140px] lg:w-auto outline-none bg-transparent text-[20px] text-[#000]"
              placeholder="0.0"
              value={fromValue}
              onChange={(e) => setFromValue(e.target.value)}
            />
            <button
              type="button"
              className="bg-[#fff] border-[#ececfe] border-[1px] rounded-[10px] px-[15px] inline-flex items-center justify-center text-[#000] font-[18px] h-[48px] min-w-[100px] gap-[12px]"
              onClick={() => {
                setActiveButton("from");
                setIsModalOpen(true);
              }}
            >
              <img src={selectedFromToken.img} className="h-[30px]" alt="" />
              {selectedFromToken.name}
            </button>
          </div>
        </div>

        <div className="text-[#000] text-[20px] font-[500] my-5 text-center">
          {" "}
          +{" "}
        </div>
        <div className="min-h-[100px] bg-gray-100 rounded-[6px] p-[16px]">
          <div className="text-[#8c8cb1] text-[14px] font-[400]">Input</div>
          <div className="flex items-center justify-between">
            <input
              type="text"
              className="border-none w-[140px] lg:w-auto outline-none bg-transparent text-[20px] text-[#000]"
              placeholder="0.0"
              value={fromValue == "" ? 0 : toValue.toLocaleString()}
              onChange={(e) => setToValue(e.target.value)}
            />
            <button
              type="button"
              className="bg-[#fff] border-[#ececfe] border-[1px] rounded-[10px] px-[15px] inline-flex items-center justify-center text-[#000] font-[18px] h-[48px] min-w-[100px] gap-[12px]"
              onClick={() => {
                setActiveButton("to");
                setIsModalOpen(true);
              }}
            >
              {selectedToToken.img && (
                <img src={selectedToToken.img} className="h-[30px]" alt="" />
              )}
              {selectedToToken.name}
            </button>
          </div>
        </div>
        <button
          type="button"
          className={`w-full mt-[30px] h-[46px] bg-[green] rounded-[99px] ${
            (Loading || isDisabled) && "bg-[lightgreen]"
          }  flex items-center justify-center text-[#fff]`}
          onClick={() =>
            address
              ? chain?.id == chains[0]?.id
                ? handleSubmit()
                : switchNetwork?.(chains[0]?.id)
              : open()
          }
          disabled={Loading || isDisabled}
        >
          {chain?.id == chains[0]?.id
            ? address
              ? Loading
                ? "Loading..."
                : errorMsg
              : "Unlock Wallet"
            : "Switch NetWork"}
        </button>
      </div>
      <TokenModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSelectToken={handleTokenSelect}
        activeButton={activeButton}
        selectedFromToken={selectedFromToken}
        selectedToToken={selectedToToken}
      />
    </>
  );
};

export default AddLiquidity;
